import EditBasic from './EditBasic';

export default EditBasic;
